import { Check } from "lucide-react";
import { QUALITY_BULLETS, waLink } from "@/lib/brand";

export const Quality = () => {
  return (
    <section
      data-testid="quality-section"
      className="relative py-24 lg:py-36 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#facc15]" />
            <span className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
              Compromisso
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
            Qualidade em cada
            <span className="italic text-[#facc15]"> detalhe</span>,
            <br />
            confiança em cada projeto.
          </h2>
          <p className="mt-8 text-zinc-400 leading-relaxed max-w-md">
            Na ATL Esquadrias, cada projeto é executado com atenção aos
            mínimos detalhes. Nosso compromisso é oferecer soluções modernas,
            funcionais e sofisticadas que agregam valor ao seu imóvel.
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="quality-whatsapp-btn"
            className="mt-10 inline-flex items-center gap-3 px-7 py-5 bg-[#facc15] text-black font-bold uppercase text-[11px] tracking-[0.28em] hover:bg-white transition-colors"
          >
            Solicitar Orçamento Sem Compromisso →
          </a>
        </div>

        <div className="lg:col-span-7 lg:col-start-7">
          <ul className="divide-y divide-white/10 border-t border-b border-white/10">
            {QUALITY_BULLETS.map((b, i) => (
              <li
                key={b}
                data-testid={`quality-bullet-${i}`}
                className="flex items-center justify-between py-6 group"
              >
                <div className="flex items-center gap-5">
                  <span className="font-display text-lg text-zinc-600 w-8">
                    0{i + 1}
                  </span>
                  <span className="font-display text-xl sm:text-2xl text-white group-hover:text-[#facc15] transition-colors">
                    {b}
                  </span>
                </div>
                <span className="flex items-center justify-center h-10 w-10 border border-white/15 text-[#facc15] group-hover:bg-[#facc15] group-hover:text-black transition-colors">
                  <Check size={18} strokeWidth={2} />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
